var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"justify":"center"}},[_c('video',{staticClass:"video",attrs:{"controls":"","controlsList":"nodownload","disablepictureinpicture":"","width":"100%","poster":_vm.thumbnail}},[_c('source',{attrs:{"src":_vm.url,"type":"video/mp4"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }